/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { sortByTitle } from './helpers/sortByTitle';

export const createProductType = createAsyncThunk(
  'productTypes/create',
  async ({ title }, { extra: { sdk, utils, Logger } }) => {
    const trimmedTitle = title.trim();
    try {
      const { data } = await sdk.productTypes.create({ title: trimmedTitle });
      return { productType: data };
    } catch (error) {
      const subcode = utils.getDataFromResponceError(error, 'subcode');
      if (subcode === 'ProductTypeAlreadyExistsApiError') {
        /** duplicate title is not a hard failure: let the caller proceed with saving it */
        return { alreadyExists: true, title: trimmedTitle };
      }
      Logger.error(new Error('Can not create product type'), { error }, [
        'CreateProductTypeFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(createProductType.pending, (state) => {
      state.error = null;
    })
    .addCase(createProductType.fulfilled, (state, { payload }) => {
      if (payload.alreadyExists) return;
      state.items = sortByTitle([...state.items, payload.productType]);
    })
    .addCase(createProductType.rejected, (state, { error }) => {
      state.error = error;
    });
};
